import { Directive, Input, Output, EventEmitter } from '@angular/core';
import { SortDirection, SortEvent } from './sort-event';

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '[class.sortable]': 'true',
    '(click)': 'rotate()',
  },
  standalone: false,
})
export class SortableDirective {
  private static readonly rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

  @Input() sortable: string;
  @Input() direction: SortDirection = '';
  @Output() sort: EventEmitter<SortEvent> = new EventEmitter<SortEvent>();
  public rotate(): void {
    this.direction = SortableDirective.rotate[this.direction];
    this.sort.emit(new SortEvent(this.sortable, this.direction));
  }
}
